import { Extension } from '@tiptap/core';

const MAX_INDENT = 6;

const Indent = Extension.create({
  name: 'indent',

  addOptions() {
    return {
      types: ['paragraph', 'heading'],
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          indent: {
            default: 0,
            parseHTML: (element) => Number(element.getAttribute('data-indent') || 0),
            renderHTML: (attributes) => {
              if (!attributes.indent) {
                return {};
              }
              return {
                'data-indent': attributes.indent,
                style: `margin-left: ${attributes.indent * 1.5}rem`,
              };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      indent:
        () =>
        ({ editor, commands }) => {
          if (editor.can().sinkListItem('listItem')) {
            return commands.sinkListItem('listItem');
          }
          const type = this.options.types.find((name) => editor.isActive(name));
          if (!type) {
            return false;
          }
          const current = Number(editor.getAttributes(type).indent || 0);
          return commands.updateAttributes(type, {
            indent: Math.min(MAX_INDENT, current + 1),
          });
        },
      outdent:
        () =>
        ({ editor, commands }) => {
          if (editor.can().liftListItem('listItem')) {
            return commands.liftListItem('listItem');
          }
          const type = this.options.types.find((name) => editor.isActive(name));
          if (!type) {
            return false;
          }
          const current = Number(editor.getAttributes(type).indent || 0);
          return commands.updateAttributes(type, {
            indent: Math.max(0, current - 1),
          });
        },
      clearFormatting:
        () =>
        ({ editor, commands }) => {
          commands.unsetMark('bold');
          commands.unsetMark('italic');
          commands.unsetMark('underline');
          commands.unsetMark('highlight');
          commands.unsetMark('strike');
          commands.unsetMark('code');
          commands.unsetHighlight();
          commands.unsetTextAlign();
          commands.unsetLink();
          commands.clearNodes();
          this.options.types.forEach((type) => {
            if (editor.isActive(type)) {
              commands.updateAttributes(type, { indent: 0 });
            }
          });
          return true;
        },
    };
  },

  addKeyboardShortcuts() {
    return {
      Tab: () => this.editor.commands.indent(),
      'Shift-Tab': () => this.editor.commands.outdent(),
    };
  },
});

export default Indent;
